module.exports = __webpack_public_path__ + "static/assets/f626ffd60cbd3c60f33ea09f1ad32092.svg";